export default {
  meta: {
    title: '招商素材详情'
  }
};
